import { ActivateEmailComponent } from './activate/activate-email/activate-email.component';
import { ActivateAccountComponent } from './activate/activate-account/activate-account.component';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DragulaModule } from 'ng2-dragula';
import { ReactiveFormsModule } from '@angular/forms';

import { TelerecourspnrSharedModule } from '../shared';

import { accountState} from './account.route';

import { FcAuthRedirectComponent } from './fc-auth-redirect/fc-auth-redirect.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { RegisterComponent } from './register/register.component';
import { PasswordStrengthBarComponent } from './password/password-strength-bar.component';
import { PasswordResetInitComponent } from './password-reset/init/password-reset-init.component';
import { PasswordResetFinishComponent } from './password-reset/finish/password-reset-finish.component';
import { CredentialsComponent } from './credentials/credentials.component';
import { SettingsComponent } from './settings/settings.component';
import { PersonneMoraleComponent } from './register/personne-morale/personne-morale.component';
import { PersonnePhysiqueComponent } from './register/personne-physique/personne-physique.component';
import { InscriptionReussieComponent } from './register/inscription-reussie/inscription-reussie.component';

import { Register } from './register/register.service';
import { Activate } from './activate/activate.service';
import { PasswordResetInit } from './password-reset/init/password-reset-init.service';
import { PasswordResetFinish } from './password-reset/finish/password-reset-finish.service';

@NgModule({
    imports: [
        TelerecourspnrSharedModule,
        DragulaModule,
        RouterModule.forRoot(accountState, { useHash: true }),
        ReactiveFormsModule
    ],
    declarations: [
        ActivateAccountComponent,
        ActivateEmailComponent,
        AuthenticationComponent,
        RegisterComponent,
        PasswordStrengthBarComponent,
        PasswordResetInitComponent,
        PasswordResetFinishComponent,
        CredentialsComponent,
        SettingsComponent,
        PersonneMoraleComponent,
        PersonnePhysiqueComponent,
        InscriptionReussieComponent,
        FcAuthRedirectComponent
    ],
    providers: [
        Register,
        Activate,
        NgbActiveModal,
        PasswordResetInit,
        PasswordResetFinish
    ],
    entryComponents: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TelerecourspnrAccountModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/account.module.ts